import { render, staticRenderFns } from "./LandlordDashboard.vue?vue&type=template&id=0a284894&scoped=true&"
import script from "./LandlordDashboard.vue?vue&type=script&lang=js&"
export * from "./LandlordDashboard.vue?vue&type=script&lang=js&"
import style0 from "./LandlordDashboard.vue?vue&type=style&index=0&id=0a284894&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a284894",
  null
  
)

export default component.exports